export const fieldTypeNames: Record<string, string> = {
  integer: "Integer number",
  decimal: "Decimal number",
  range: "Slider",
  text: "Text field",
  select_one: "Single choice",
  select_one_from_file: "Single choice from file",
  select_multiple: "Multiple choice",
  select_multiple_from_file: "Multiple choice from file",
  rank: "Rank items",
  note: "Note / Hint",
  geopoint: "Locate a point",
  geotrace: "Trace a line",
  geoshape: "Draw a shape",
  date: "Date",
  time: "Time",
  datetime: "Date and time",
  image: "Image",
  audio: "Audio",
  video: "Video",
  file: "File",
  barcode: "Scan a code",
  acknowledge: "Checkbox",
  calculate: "Calculate formula",
  hidden: "Hidden field",
  "xml-external": "External XML reference",
  start: "Survey start date and time",
  end: "Survey submission date and time",
  today: "Survey start day",
  deviceid: "Device ID",
  simserial: "SIM serial number",
  subscriberid: "Subscriber ID",
  phonenumber: "Phone number",
  username: "Username",
  email: "Email address",
  audit: "Audit trail",
  begin_group: "Field group",
  begin_repeat: "Repeat group",
};
